<script lang="ts" setup name="OrganisationPortCallsIndex">
//TODO: Fix <TimelineChart :rows="rows" :buffer-days="75" />
import { ref } from 'vue';

import { useLastUpdated } from '~/features/useLastSync';
import { mapVoyageToTimelineRow } from '~/features/usePortCallsTimeline';
import { useService } from '~/features/useService';

import Service from '~/services/Service.js';

import BasePage from '~/components/BasePage.vue';
import ServiceCard from '~/components/ServiceCard.vue';
import TimelineChart from '~/components/TimelineChart.vue';

import type {
  IDataTableAction,
  IPageResponse,
  IPortCallVoyage,
  ITimelineChartBaseRow,
} from '~/types';

const { organisationId } = defineProps<{
  organisationId: OrganisationId;
}>();

const { lastUpdated, setLastUpdated } = useLastUpdated();

const voyageRows = ref<ITimelineChartBaseRow[]>([]);

const actions = (data): IDataTableAction[] => {
  const selectedRow = voyageRows.value.find(
    (voyageRow) => voyageRow.id === data?.rowId,
  );

  const selectedBar = selectedRow?.bars.find((bar) => bar.id === data.barId);

  return [
    {
      to: {
        name: 'OrganisationPortCallsDetailsOverview',
        params: {
          portId: selectedBar?.lastVoyagePortId,
        },
      },
      key: 'view',
      icon: 'mdi:eye',
      dataTestId: 'row-view',
      tooltipDescription: 'View',
      variant: 'btn-tertiary',
    },
  ];
};

const serviceState = useService(
  Service.organisation(organisationId).portCallsCalls().index(),
  ({ data, meta }: IPageResponse<IPortCallVoyage[]>) => {
    if (!data.length) return false;
    voyageRows.value = mapVoyageToTimelineRow(data);
    setLastUpdated(meta?.lastUpdated);
    return true;
  },
);
</script>
<template>
  <BasePage title="Port Calls" :last-updated="lastUpdated">
    <ServiceCard v-bind="serviceState" styled>
      <div class="col-span-full">
        <TimelineChart :rows="voyageRows" :actions="actions" />
      </div>
    </ServiceCard>
  </BasePage>
</template>
